import request from "utils/request";
import getApiRoot from "./getApiRoot";

export function getGameTemplates() {
    return request()
        .get(`${getApiRoot()}/v1/services/bigames/templates/admin/`)
        .send();
}

export function getGameTemplate(templateId) {
    return request()
        .get(`${getApiRoot()}/v1/services/bigames/templates/admin/${templateId}`)
        .send();
}

export function updateGameTemplate(template) {
    return request()
        .put(`${getApiRoot()}/v1/services/bigames/templates/${template.greenlineGameTemplateId}/gamesettings`)
        .send(template);
}

export function getProviderGameTemplates(filters) {
    return request()
        .query(filters)
        .get(`${getApiRoot()}/v1/services/bigames/games/`)
        .send();
}

export function getTemplates(filters) {
    return request()
        .query(filters)
        .get(`${getApiRoot()}/v1/services/bigames/templates/`)
        .send();
}
